import { Children, cloneElement, useEffect } from 'react';

import { useMasterInviteTemplateGetQuery } from '../../Common/Queries/masterInviteTemplateQueries';
import { usePositionsPostQuery } from '../../Common/Queries/positionsQueries';
import { useTemplateGetQuery } from '../../Common/Queries/templateQueries';

import { htmlToMD } from '../../utils';

/**
 * @function formateData
 * @param values
 * @returns formated values
 */
export const formateData = (values) => {
  return {
    status: values.status,
    description: htmlToMD(values.description),
    location: values.location,
    title: values.title,
    interviewer: values.interviewer,
    hr: values.hr,
    isCampus: values.isCampus,
    isPublic: values.isPublic,
    skill: values.skill,
    stream: values.stream,
    level: values.level,
    offlineInviteTemplate: values.offlineInviteTemplate,
    onlineInviteTemplate: values.onlineInviteTemplate,
    endDate: values.endDate,
    skipRounds: values.skipRounds,
    wordCountLimit: values.wordCountLimit,
    templateID: values.templateID,
    customFormData: values?.customFormData ?? [],
    isAcceptingApplication: values.isAcceptingApplication ?? true,
    attachments: values?.attachments ?? [],
    acknowledgmentInformation: values?.acknowledgmentInformation ?? [],
  };
};

export function AddPositionContainer({ setOpen, skipMasterTemplate, children, ...props }) {
  const postToPositions = usePositionsPostQuery();
  const getMasterInviteTemplates = useMasterInviteTemplateGetQuery(undefined, {
    enabled: !skipMasterTemplate,
  });
  const offerLetterTemplatesResponse = useTemplateGetQuery();

  function handleSubmitForAddPosition(values) {
    const reqBody = formateData(values);
    postToPositions.mutate(reqBody);
  }

  useEffect(() => {
    if (postToPositions.isSuccess) {
      setOpen(false);
    }
  }, [postToPositions.isSuccess]);

  return Children.only(
    cloneElement(children, {
      postToPositions,
      getMasterInviteTemplates,
      handleSubmitForAddPosition,
      offerLetterTemplatesResponse,
      ...props,
    })
  );
}
